/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Stat_PeopleInputs */

const cs_settings_teams_stat_people = /** @type {(inputs: Settings_Teams_Stat_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lidé v týmech`)
};

const en_settings_teams_stat_people = /** @type {(inputs: Settings_Teams_Stat_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People on teams`)
};

/**
* | output |
* | --- |
* | "People on teams" |
*
* @param {Settings_Teams_Stat_PeopleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_stat_people = /** @type {((inputs?: Settings_Teams_Stat_PeopleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Stat_PeopleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_stat_people(inputs)
	return cs_settings_teams_stat_people(inputs)
});